<div class="gather-estimates-container">
  <!-- Upload section -->
  @if (!data.disabledLock) {
    <div class="gather-estimates-upload-section mb-6">
      <button type="button" class="btn--secondary pl-3" (click)="data.vendorEstimateUploadClick()">
        <aux-icon name="Send" />
        <span class="ml-2">Send Vendor Estimate Support</span>
      </button>
    </div>
  }

  <!-- Upload-disabled section -->
  @if (data.disabledLock) {
    <div class="gather-estimates-upload-section mb-6">
      <button
        type="button"
        class="btn--secondary gather-estimates-upload-section-disabled pl-3"
        disabled
      >
        <aux-icon name="Send" />
        <span class="ml-2">Send Vendor Estimate Support</span>
      </button>
    </div>
  }

  <!-- Vendor Contract section -->
  <div class="gather-estimates-vendor-section flex">
    <div class="gather-estimates-vendor-header gather-estimates-vendor-row flex">
      <div class="-mb-2 flex-grow">Vendor Contracts</div>
      <div class="flex w-48 justify-center text-center">Available in Auxilius</div>
    </div>

    <div class="gather-estimates-vendor-row-container flex flex-grow flex-col">
      @for (vendor of vendorEstimateSummaries; track vendor) {
        <div class="gather-estimates-vendor-row flex flex-grow">
          <!-- Vendor Contract name -->
          <div class="flex-grow">
            <span
              class="btn--hyperlink cursor-pointer px-0"
              [auxTooltip]="vendor.name"
              (click)="navigateToVendor(vendor.id)"
            >
              {{ vendor.name }}
            </span>
          </div>

          <!-- Available in Auxilius -->
          <div class="flex w-48 justify-center">
            @if (vendor.vendorEstimateExists) {
              <aux-icon name="Check" class="gather-estimates-vendor-row-check" />
            }
            @if (!vendor.vendorEstimateExists) {
              <span class="gather-estimates-vendor-row-x-mark">
                <aux-icon name="X" />
              </span>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
